import { createFileRoute } from "@tanstack/react-router";
import { RegionalHubPage, hubSchemaScripts, seoHead } from "@/components/hubs/HubPages";
import { REGIONAL_HUBS } from "@/lib/regionalHubs";

const DATA = REGIONAL_HUBS.find((x) => x.path === "/pikes-peak-contractor-marketing")!;
const DESC = "Local websites, SEO and Google Maps for Colorado Springs contractors: roofers, HVAC, plumbers and electricians in Monument, Falcon, Peyton, Woodland Park and Fountain.";

export const Route = createFileRoute("/pikes-peak-contractor-marketing")({
  head: () => seoHead("/pikes-peak-contractor-marketing", "Contractor Marketing Colorado Springs, Monument & Falcon", DESC, "website", hubSchemaScripts(DATA, DESC)),
  component: () => <RegionalHubPage hub={DATA} />,
});
